import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from "react";

interface VisibilityContextValue {
  activeItemId: string | null;
  setActiveItemId: (itemId: string | null) => void;
}

const VisibilityContext = createContext<VisibilityContextValue | null>(null);

export function VisibilityProvider({ children }: { children: ReactNode }) {
  const [activeItemId, setActiveItemId] = useState<string | null>(null);

  return (
    <VisibilityContext.Provider value={{ activeItemId, setActiveItemId }}>
      {children}
    </VisibilityContext.Provider>
  );
}

export function useVisibility() {
  return useContext(VisibilityContext);
}

export function useHoverTracking(itemId: string) {
  const context = useContext(VisibilityContext);

  const onMouseEnter = useCallback(() => {
    context?.setActiveItemId(itemId);
  }, [context, itemId]);

  return { onMouseEnter };
}
